<template>
  <div class="stk-checkboxes">
    <label
      v-for="option in options"
      :key="option.value"
      class="stk-checkbox"
    >
      <input
        type="checkbox"
        :name="`${name}[]`"
        :value="option.value"
        :checked="isChecked(option.value)"
        @change="(e) => handleChange(option.value, e)"
      >
      {{ option.label }}
    </label>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: Array,
    required: true,
    default: () => [],
  },
  options: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['input']);

const isChecked = (val) => props.value.includes(val);

const coerceToOptionType = (raw, optionValSample) => {
  if (typeof optionValSample === 'number') return Number(raw);
  if (typeof optionValSample === 'boolean') return raw === 'true';
  return raw; // string or others
};

const handleChange = (optionValue, event) => {
  const { checked, value: raw } = event.target;
  const coerced = coerceToOptionType(raw, optionValue);

  const next = props.value.slice(); // copy
  const idx = next.indexOf(coerced);

  if (checked && idx === -1) next.push(coerced);
  if (!checked && idx !== -1) next.splice(idx, 1);

  emit('input', next); // Vue 2 v-model update
};
</script>
